import { Route, Switch } from 'react-router-dom';
import { isUserPermitted } from '../../../TowerMenu/TowerMenuUtils';
import { useGetUserData } from '../../../api';
import CreateApplication from '../components/CreateApplication/CreateApplication';
import { ROLES } from '@silverfort-nodelibs/common/utils/consts';
import { ActiveDirectoryAccessPage } from '../screens/ActiveDirectoryAccessPage';
import { ApplicationPage } from '../components/access/application-page/ApplicationPage';

export const AccessAnalysisActiveDirectoryRoutes = () => {
    const { userSession } = useGetUserData();

    const isUserEditor = isUserPermitted(userSession, 'accessAnalysis', ROLES.EDITOR.value);

    return (
        <>
            <Switch>
                <Route component={ActiveDirectoryAccessPage} exact path="/AccessAnalysis" />
                <Route component={ApplicationPage} exact path="/AccessAnalysis/Application/:appId" />

                {isUserEditor && <Route component={CreateApplication} exact path="/AccessAnalysis/Create" />}
            </Switch>
        </>
    );
};
